import { render, staticRenderFns } from "./Test.vue?vue&type=template&id=3f1c94a6&"
import script from "./Test.vue?vue&type=script&lang=ts&"
export * from "./Test.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports